module.exports = __webpack_public_path__ + "img/btn_upgrade.09c5fb87.png";